import type {SuggestResponse, FinalizeSuggestResponse} from '@yandex-delivery/api/repo/suggest/types'

function isFinalizeSuggestResponse(response: SuggestResponse): response is FinalizeSuggestResponse {
  return 'services' in response
}

export function checkServiceAvailability(response: SuggestResponse) {
  if (isFinalizeSuggestResponse(response)) {
    const taxiUnavailabilityReason = response.services?.taxi.unavailability_reason?.message

    if (taxiUnavailabilityReason) {
      throw new Error(taxiUnavailabilityReason)
    }
  }

  return response
}
